<template>
  <v-content class="pa-12">
    <v-layout justify-space-around>
      <v-flex
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>จัดการใบ Certificate</span>
      </v-flex>
    </v-layout>
    <!-- Table -->
    <v-layout mt-6>
      <v-flex>
        <form-table
          :headers="headers"
          :items="userList"
          on-view-data
          :viewCertificate="viewCertificate"
          :updateCertificate="updateCertificate"
          :remakeCertificate="remakeCertificate"
        ></form-table>
      </v-flex>
    </v-layout>

    <!-- MODAL -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <!-- Header -->
            <div class="py-4 mb-6" style="background-color: #3e7662">
              <span
                style="font-weight: bold;text-align: center;font-size: 22px;color: white;"
              >
                การอนุมัติใบ Certificate
              </span>
            </div>
            <v-card-text>
              <!-- row 1 -->
              <v-layout px-6 style="font-weight: bold;">
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span>ชื่อ-นามสกุล</span>
                </v-flex>
                <v-flex justify-start align-center d-flex>
                  <v-text-field
                    v-model="form.name"
                    disabled
                    dense
                    outlined
                    hide-details
                  />
                </v-flex>
              </v-layout>
              <!-- row 2 -->
              <v-layout mt-6 px-6 style="font-weight: bold;">
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;">วันที่ออก Certificate</span>
                </v-flex>
                <v-flex justify-start align-center d-flex>
                  <v-text-field
                    v-model="form.certificateDate"
                    disabled
                    outlined
                    dense
                    hide-details
                  />
                </v-flex>
              </v-layout>
              <!-- row 3 -->
              <v-layout mt-6 px-6 style="font-weight: bold;">
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;">วันคงเหลือ</span>
                </v-flex>
                <v-flex justify-start align-center d-flex>
                  <v-text-field
                    v-model="form.remainingDate"
                    disabled
                    outlined
                    dense
                    hide-details
                  />
                </v-flex>
              </v-layout>
              <!-- row 4 -->
              <v-layout mt-6 px-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;">สถานะ : </span>
                </v-flex>
                <v-flex justify-start align-center d-flex>
                  <v-radio-group hide-details v-model="form.status" row>
                    <v-radio
                      color="#3E7662"
                      label="อนุมัติ"
                      value="1"
                    ></v-radio>
                    <v-radio
                      color="#3E7662"
                      label="รอการพิจารณา"
                      value="0"
                    ></v-radio>
                    <v-radio
                      color="#3E7662"
                      label="ไม่อนุมัติ"
                      value="2"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <!--reject reason-->
              <v-layout mt-6 px-6 style="font-weight: bold;" v-if="form.status == 2">
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;">เหตุผลที่ไม่อนุมัติ</span>
                </v-flex>
                <v-flex justify-start align-center d-flex>
                  <v-textarea
                      v-model="form.rejectReason"
                      outlined
                      dense
                      hide-details
                  />
                </v-flex>
              </v-layout>

              <v-layout class="mt-12 mb-4">
                <v-spacer></v-spacer>
                <v-flex xs2>
                  <v-btn style="font-weight: bold" @click="dialog = false"
                    ><span style="color: #3e7662">ยกเลิก</span></v-btn
                  >
                </v-flex>
                <v-flex xs2>
                  <v-btn
                    style="font-weight: bold"
                    color="#3E7662"
                    dark
                    @click="updateCertificate"
                    >บันทึก</v-btn
                  >
                </v-flex>
                <v-spacer></v-spacer>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Pagination -->
    <v-layout mt-6>
      <v-flex>
        <v-pagination
          color="#3E7662"
          :length="paginateUser.last_page"
          :total-visible="9"
          @input="getCertificateList"
          v-model="paginateUser.current_page"
        ></v-pagination>
      </v-flex>
    </v-layout>
    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import FormTable from "../../components/table/FormTable";
import { mapState } from "vuex";
export default {
  components: {
    FormTable,
    Loading,
  },
  data: () => ({
    paginateUser: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    dialog: false,
    form: {
      id: "",
      name: "",
      certificateDate: "",
      remainingDate: "",
      status: "",
      rejectReason: ""
    },
    isLoading: false,
    fullPage: true,
    headers: [
      {
        text: "ลำดับ",
        value: "number",
        align: "center",
        sortable: false,
        class: "header-data-table",
      },
      { text: "ชื่อ-นามสกุล", value: "name", align: "center", sortable: false },
      {
        text: "วันที่ออก Certificate",
        value: "createDate",
        align: "center",
        sortable: false,
      },
      {
        text: "วันเวลาที่ส่ง",
        value: "sendDate",
        align: "center",
        sortable: false,
      },
      { text: "วันคงเหลือ",
        value: "dayRemaining",
        align: "center" ,
        sortable: false,
      },
      {
        text: "สถานะ Certificate",
        value: "status",
        align: "center",
        sortable: false,
      },
      {
        text: "ดูใบ Certificate",
        value: "viewCer",
        align: "center",
        sortable: false,
      },
      {
        text: "อนุมัติใบ Certificate",
        value: "checkCer",
        align: "center",
        sortable: false,
      },
      {
        text: "Regen Certificate",
        value: "regenCer",
        align: "center",
        sortable: false,
      },
    ],
    userList: [],
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    // Check Permission Access
    //    if (this.user.currentRole !== 1) {
    //        this.$router.go(-1);
    //   }
    this.getCertificateList(1);
  },
  methods: {
    viewCertificate(item) {
      this.form.id = item.id;
      this.form.name = item.name;
      this.form.certificateDate = item.createDate;
      this.form.remainingDate = item.dayRemaining;
          this.form.rejectReason = item.rejectReason;
      this.form.status =
        item.status === "อนุมัติ"
          ? "1"
          : "" || item.status === "รอการพิจารณา"
          ? "0"
          : "" || item.status === "ไม่อนุมัติ"
          ? "2"
          : "";
      this.dialog = true;
    },
    updateCertificate() {
      let data = {
        id: this.form.id,
        status: this.form.status,
        rejectReason: this.form.status == 2 ? this.form.rejectReason : ''
      };
      this.isLoading = true;
      this.$store
        .dispatch("User/updateCertificate", data)
        .then((res) => {
          this.isLoading = false;
          Swal.fire({
            title: "อัพเดตเรียบร้อยแล้ว",
            icon: "success",
            position: "center",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.dialog = false;
            this.getCertificateList(1);
          });
        })
        .catch((e) => {
          this.isLoading = false;
          if (e.response.data.errors) {
            for (var k in e.response.data.errors) {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: e.response.data.errors[k][0],
                icon: "warning",
                confirmButtonColor: "#3E7662",
              }).then(() => {
                this.$vuetify.goTo(`#${k}`);
              });
            }
          }
          // Swal.fire({
          //     title: "เกิดข้อผิดพลาด",
          //     text: "บันทึกไม่สำเร็จ",
          //     icon: 'warning'
          // });
        });
    },
    remakeCertificate(item) {
      Swal.fire({
        title: "ต้องการสร้าง Certificate ใหม่หรือไม่?",
        text: item.name,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "สร้างใหม่",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (!result.value) {
          return;
        }

        this.isLoading = true;
        this.$store
          .dispatch("User/remakeCertificate", item.id)
          .then(() => {
            this.isLoading = false;
            Swal.fire({
              title: "สร้าง Certificate ใหม่เรียบร้อยแล้ว",
              icon: "success",
              position: "center",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              this.getCertificateList(this.paginateUser.current_page);
            });
          })
          .catch((e) => {
            this.isLoading = false;
            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              text:
                (e.response &&
                  e.response.data &&
                  (e.response.data.message || e.response.data.error)) ||
                "สร้าง Certificate ใหม่ไม่สำเร็จ",
              icon: "warning",
              confirmButtonColor: "#3E7662",
            });
          });
      });
    },
    getCertificateList(page) {
      this.isLoading = true;
      this.$store
        .dispatch("User/getCertificateList", page)
        .then((res) => {
          this.userList = [];
          let i = 1;
          res.data.forEach((data) => {
            this.userList.push({
              number: i,
              name: data.preNameTh ? data.preNameTh + " " + data.thName : data.thName,
              createDate: data.certificate_create_at,
              dayRemaining: data.remainingDay,
              sendDate: data.sendDate,
              status: this.checkStatus(data.certificateStatus),
              rejectReason: data.rejectReason,
              id: data.id,
              viewCer: data.certificate,
              onView: 13,
            });
            i++;
          });
          this.paginateUser.current_page = res.current_page;
          this.paginateUser.from = res.from;
          this.paginateUser.last_page = res.last_page;
          this.paginateUser.per_page = res.per_page;
          this.paginateUser.total = res.total;
          this.paginateUser.to = res.to;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        });
    },
    checkStatus(val) {
      if (val === 1) {
        return "อนุมัติ";
      } else if (val === 2) {
        return "ไม่อนุมัติ";
      } else {
        return "รอการพิจารณา";
      }
    },
  },
};
</script>

<style lang="scss">
.header-data-table {
  font-size: 20px;
}
</style>
